import { ReactNode, useEffect } from "react";
import { Drawer, Button, Space, Form } from "antd";
import { TableViewFilters } from "../../interfaces/table-view";
import { formatISODateFields } from "../../utils/helper";

interface FilterDrawerProps {
  open: boolean;
  onClose: () => void;
  onClear?: () => void;
  onApply: (filters: TableViewFilters) => void;
  values?: TableViewFilters;
  children: ReactNode;
  title?: string;
  width?: number
}

const FilterDrawer: React.FC<FilterDrawerProps> = ({
  open,
  onClose,
  onApply,
  onClear,
  children,
  values = {},
  title = "Filter",
  width = 520
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open && values) {
      form.setFieldsValue(formatISODateFields(values));
    }
  }, [open, values, form]);

  const handleApply = () => {
    const values: TableViewFilters = form.getFieldsValue();
    onApply(values);
    onClose?.();
  };

  const handleClear = () => {
    form.resetFields();
    onClear?.();
  };

  return (
    <Drawer
      title={title}
      onClose={onClose}
      open={open}
      width={width}
      footer={
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button onClick={handleClear} type="link">
            Clear All
          </Button>
          <Space>
            <Button onClick={onClose}>Cancel</Button>
            <Button type="primary" onClick={handleApply}>
              Apply
            </Button>
          </Space>
        </div>
      }
    >
      <Form form={form} layout="vertical">
        {children}
      </Form>
    </Drawer>
  );
};

export default FilterDrawer;
